import { Link } from "react-router-dom";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import SEOHead from "@/components/SEOHead";
import RecentLocalProjects from "@/components/landing/RecentLocalProjects";
import { Button } from "@/components/ui/button";

const faqItems = [
  {
    question: "What work has All Time Paint & Plaster Co. completed in Clifton?",
    answer:
      "Our Clifton work includes a hand-applied limewash on the walls and ceilings of Coffiyeh coffee shop on Lakeview Avenue, with the new wood counter stained to match, and a Meoded Concretta FS microcement checkout counter for Veiled.",
  },
  {
    question: "Do you work on commercial spaces in Clifton?",
    answer:
      "Yes. Both of our documented Clifton projects are commercial interiors: a coffee shop and a retail checkout counter.",
  },
  {
    question: "Can I see plaster, limewash and microcement samples before choosing a finish?",
    answer:
      "Yes. Our office at 1581 Route 23 South, Suite 1, Wayne, NJ is a short drive from Clifton. Book a finish consultation to see samples in person.",
  },
];

const CliftonNJ = () => (
  <>
    <SEOHead
      title="Limewash & Microcement in Clifton, NJ | All Time Paint & Plaster Co."
      description="Real Clifton, NJ projects by All Time Paint & Plaster Co.: limewash walls and ceilings at Coffiyeh coffee shop and a microcement checkout counter. Request an estimate."
      canonicalUrl="https://alltimepaintandplaster.com/clifton-nj/"
      serviceSchema={{
        name: "Limewash, Microcement & Painting in Clifton, NJ",
        description:
          "Limewash, microcement, decorative plaster and painting for homes and businesses in Clifton, New Jersey, by All Time Paint & Plaster Co. of Wayne, NJ.",
        serviceType: "Decorative Wall Finishes",
      }}
      faqItems={faqItems}
      isServicePage
      serviceName="Limewash & Microcement"
      townName="Clifton"
    />
    <Header />
    <main className="min-h-screen bg-background">
      <section className="py-16 md:py-24 border-b border-border">
        <div className="container mx-auto px-4 max-w-3xl">
          <nav aria-label="Breadcrumb" className="text-xs uppercase tracking-wider text-muted-foreground mb-6">
            <Link to="/" className="hover:text-primary">Home</Link> / <Link to="/service-areas/" className="hover:text-primary">Service Areas</Link> / Clifton
          </nav>
          <p className="text-xs uppercase tracking-[0.2em] text-primary mb-3">Clifton, New Jersey</p>
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-6">
            Limewash & Microcement in Clifton, NJ
          </h1>
          <p className="text-lg text-muted-foreground mb-4">
            All Time Paint & Plaster Co. has completed commercial limewash and microcement work in Clifton. At Coffiyeh coffee shop on Lakeview Avenue, we hand-applied limewash to the walls and ceilings and stained the new wood counter. For Veiled, we finished a checkout counter in Meoded Concretta FS microcement.
          </p>
          <p className="text-lg text-muted-foreground mb-8">
            We're based in Wayne, a short drive away, and also handle interior painting and decorative plaster for Clifton homes and businesses.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild size="lg"><Link to="/contact/?source=clifton">Request an Estimate</Link></Button>
            <Button asChild size="lg" variant="outline"><Link to="/book/">Schedule a Finish Consultation</Link></Button>
          </div>
        </div>
      </section>

      <RecentLocalProjects
        towns={["Clifton, NJ"]}
        heading="Our Clifton Projects"
        intro="Two documented commercial projects, each with its own write-up and photos."
      />

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-6">Services for Clifton</h2>
          <ul className="space-y-3 text-muted-foreground">
            <li><Link to="/services/limewash-painting/" className="text-primary hover:underline">Limewash Painting</Link>: a lime-based mineral coating with soft movement, as used at Coffiyeh.</li>
            <li><Link to="/plaster-showers-nj/" className="text-primary hover:underline">Microcement & Plaster Showers</Link>: seamless microcement for counters, walls and bathrooms.</li>
            <li><Link to="/plaster-services/" className="text-primary hover:underline">Decorative Plaster Services</Link>: Venetian and lime plaster finishes.</li>
            <li><Link to="/painting-services/" className="text-primary hover:underline">Professional Painting</Link>: interior and exterior painting.</li>
          </ul>
        </div>
      </section>

      <section className="py-16 bg-muted/30 border-t border-border">
        <div className="container mx-auto px-4 max-w-3xl">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-6">Clifton Questions</h2>
          <div className="space-y-6">
            {faqItems.map((f) => (
              <div key={f.question}>
                <h3 className="font-heading font-semibold text-foreground mb-2">{f.question}</h3>
                <p className="text-muted-foreground">{f.answer}</p>
              </div>
            ))}
          </div>
          <p className="mt-8 text-sm text-muted-foreground">
            Nearby: <Link to="/plaster-limewash-wayne-nj/" className="text-primary hover:underline">Wayne</Link> ·{" "}
            <Link to="/montclair-nj/" className="text-primary hover:underline">Montclair</Link>
          </p>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default CliftonNJ;
